import React, { useContext } from 'react'
import SettingsContext from '../../context/SettingsContext/SettingsContext';
import NavbarReturnBody from './NavbarReturnBody';
import { t } from 'i18next';
import { useBasePath } from '../../customHooks/useBasePath';
import { getTenantInfoByKey } from '../../helpers/helpers';
import buildingIcon from '../../assets/icons/building-icon.svg';
import peopleToVisitIcon from '../../assets/icons/people-to-visit-icon.svg';
import sectorIcon from '../../assets/icons/sector-icon.svg';

const NavSettingsBody = () => {
    const path = useBasePath();

    const nameOfBuildings = getTenantInfoByKey('building_name');
    const nameOfArea = getTenantInfoByKey('area_name');

    const { settingsState } = useContext(SettingsContext);
    const { showSection } = settingsState;

    const commonRouteBuilding = '/settings/entityManagment/buildingsMaganagement';
    const commonRouteArea = '/settings/entityManagment/areasMaganagement';
    const commonRoutePeopleToVisit = '/settings/entityManagment/peopleToVisitMaganagement';
    const commonRouteSectors = '/settings/entityManagment/sectorMaganagement';
    const commonRouteequipmentOrTools = '/settings/entityManagment/equipmentOrToolsMaganagement';

    const routesWithNamesAndIcons = {
        buildingsMaganagement: {
            name: nameOfBuildings,
            icon: buildingIcon,
            route: commonRouteBuilding
        },
        areasMaganagement: {
            name: nameOfArea,
            icon: null,
            route: commonRouteArea
        },
        peopleToVisitMaganagement: {
            name: t('PERSON_TO_VISIT'),
            icon: peopleToVisitIcon,
            route: commonRoutePeopleToVisit
        },
        sectorMaganagement: {
            name: t('SECTORS'),
            icon: sectorIcon,
            route: commonRouteSectors
        },
        equipmentOrToolsMaganagement: {
            name: t('EQUIPMENT_OR_TOOLS'),
            icon: null,
            route: commonRouteequipmentOrTools
        },
    }

    const route = path;
    let part = route.split("/");
    let lastSegment = part[part.length - 1];
    let typeOfRoute = part[part.length - 2];

    const otherRedirection = () => {

        //when user refreshes the page
        if (showSection.length === 0) {
            if (routesWithNamesAndIcons[typeOfRoute]) {
                return routesWithNamesAndIcons[typeOfRoute].route;
            }
        }

        if (routesWithNamesAndIcons[showSection.key] && (lastSegment === 'create' || lastSegment === 'edit')) {
            return routesWithNamesAndIcons[showSection.key].route;
        }

        return showSection?.backRoute;

    }

    const getTitleBySection = () => {

        const createAndEditWord = {
            create: t('CREATE'),
            edit: t('EDIT')
        }

        if (createAndEditWord[lastSegment]) {
            if (routesWithNamesAndIcons[typeOfRoute]) {
                return `${createAndEditWord[lastSegment]} ${routesWithNamesAndIcons[typeOfRoute].name}`
            }
        }
        return showSection?.navName;
    }

    const getIconBySection = () => {

        if (showSection.length === 0) {
            if (routesWithNamesAndIcons[typeOfRoute]) {
                return routesWithNamesAndIcons[typeOfRoute].icon;
            }
        }

        if (routesWithNamesAndIcons[showSection.key]) {
            return routesWithNamesAndIcons[showSection.key].icon
        }
        return null;
    }

    return (
        <NavbarReturnBody
            title={getTitleBySection()}
            icon={getIconBySection()}
            returnTo={otherRedirection()}
        />
    )
}

export default NavSettingsBody;